import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { t as tFn, LANGS } from "@/lib/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("eazy_lang") || "en";
  });

  useEffect(() => {
    localStorage.setItem("eazy_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => tFn(lang, path), [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t, langs: LANGS }),
    [lang, t]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
